/* eslint-disable */
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import store from '@/store';
import Cookie from '@/utils/cookie.js';
import { isUnlogin } from '@/pre-init';
import showAuthenticationDialog from '@components/authenticationDialog';

const BASEURL = process.env.VUE_APP_SCM_API || '';

let loadingService = null;
function closeLoading() {
  if (loadingService) {
    loadingService.close();
    loadingService = null;
  }
}

const CancelToken = axios.CancelToken;
let requestQueue = [];

axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data';
axios.loadingRequestQueue = [];

const result_list = {
  1: 'success',
  2: '参数异常',
  3: '服务端运行异常',
  4: '服务端内部错误',
  5: '服务端内部调用失败',
  6: '淘宝服务调用失败',
  7: '调用内部程序失败',
  8: '用户没有权限',
};

/**
 * 初始化默认 接口配置
 */
let initConfig = {
  isNeedLoading: true,
};

axios.interceptors.request.use(
  config => {
    // begin loading...
    // config.data = qs.stringify(config.data); // 转为formdata数据格式
    // handleRequest({ config })
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

axios.interceptors.response.use(
  response => {
    // handleResponse({ config: response.config })
    // finish loading...
    if (response && response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    const Message = Vue.prototype.$message;
    if (error?.config?.isSilentRequest) {
      return Promise.reject(error);
    }
    // closeLoading();
    // 接口超时 报异常
    if (error.message.includes('timeout')) {
      return Promise.reject(error);
    }
    if (error.message.includes('Network Error')) {
      Message.error('网络出错');
      return Promise.reject(error);
    }
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          Message.error('400 请求参数有误');
          break;
        case 401:
          Message.error('401 请求未授权');
          break;
        case 403:
          Message.error('403 请求被拒绝');
          break;
        case 404:
          Message.error(error.response.config.url + ' 404 请求资源未被发现');
          break;
        case 405:
          Message.error(error.response.config.url + `[${error.response.config.method}]` + ' 405 未被允许方法');
          break;
        case 500:
          Message.error('500 服务器异常');
          break;
        case 501:
          Message.error('501 服务器不支持当前请求');
          break;
        case 502:
          Message.error('502 网关出错');
          break;
        case 503:
          Message.error('503 服务不可用');
          break;
        case 504:
          Message.error('504 网关超时');
          break;
        default:
          Message.error('网络出错');
      }
      return Promise.reject(error);
    }
  }
);

/**
 * 判断是否有接口还未加载完
 * @param {*} uniqueKey
 */
function compareLoadingStatus(uniqueKey) {
  const targetIndex = axios.loadingRequestQueue.findIndex(item => item.uniqueKey === uniqueKey);
  if (targetIndex > -1) {
    axios.loadingRequestQueue.splice(targetIndex, 1);
  }
  if (!axios.loadingRequestQueue.length) {
    closeLoading();
  }
}

/**
 * 接口增加参数 api_name
 * @param {*} url
 */
function get_api_name(url) {
  const target = url.match(/(http:\/\/|https:\/\/).+?\//);
  const str = target ? target[0] : '';
  url = url.replace(str, '');
  if (url && (typeof url).toLowerCase() === 'string') {
    return target ? url.replace(/[\/]/g, '_') : url.substring(1).replace(/[\/]/g, '_');
  }
}

/**
 * 请求拦截
 * @param {*} param0
 */
function handleRequest({ config }) {
  // 提取四个参数用于区分相同的请求
  const { url, method, data = {}, params = {} } = config;
  const jData = JSON.stringify(data),
    jParams = JSON.stringify(params);

  const padding = requestQueue.filter(item => {
    return item.url === url && item.method === method && item.data === jData && item.params === jParams;
  });

  if (padding.length) {
    // 这里是重点，实例化CancelToken时，对参数 c 进行立即调用，即可立即取消当前请求
    config.cancelToken = new CancelToken(c => c(`重复的请求被主动拦截: ${url} + ${jData} + ${jParams}`));
  } else {
    // 如果请求不存在，将数据转为JSON字符串格式，后面比较好对比
    requestQueue.push({
      url,
      data: jData,
      params: jParams,
      method,
    });
  }
}

// 响应拦截调用
function handleResponse({ config }) {
  const { url, data = JSON.stringify({}), params = JSON.stringify({}) } = config;
  let reqQueue = requestQueue.filter(item => {
    return item.url !== url && item.data !== data && item.params !== params;
  });
  requestQueue = reqQueue;
}

// 处理错误信息
function _errResp(errmsg) {
  // 错误信息中有这两个字符串就更改错误提示语
  if (/\/verify.html/.test(errmsg) || /\/mobile.html/.test(errmsg)) {
    return '平台api需要身份验证，请先登录快麦erp';
  } else {
    return errmsg;
  }
}

// 判断当前请求cookie是否和之前一致，“不一致提示用户信息已更新，请刷新”
let cookieDiffing = false;
const isDiffCookie = (url, params) => {
  const MessageBox = window._globel_vm ? window._globel_vm.$msgbox : placeholderFn;
  const whiteUrls = [
    '/grayNames/search',
    '/account/login',
    '/account/loginGainValidateCode',
    '/account/checkCompanyExists',
    '/account/checkPhoneExists',
    '/account/gainIdentifyCode',
    '/account/register',
    '/account/getPhoneCode',
    '/user/querySupplyUserInfo',
    '/user/info',
    '/item/base/detailByOceanItemIds',
  ];
  if (
    whiteUrls.some(wurl => {
      if (url.indexOf(wurl) > -1) {
        if (wurl === '/account/loginGainValidateCode') {
          return params.key === 'l';
        } else if (wurl === '/account/gainIdentifyCode') {
          return params.status === 0;
        } else {
          return true;
        }
      } else {
        return false;
      }
    })
  ) {
    return false;
  }

  let nowCenseid = `${Cookie.get('_censeid')}_${store.getters.userInfo.id}`;
  let preCenseid = localStorage.getItem('_censeid');

  if (!preCenseid) {
    localStorage.setItem('_censeid', nowCenseid);
    return false;
  }

  if (preCenseid && nowCenseid && preCenseid !== nowCenseid && store.getters.userInfo.id !== undefined) {
    if (cookieDiffing) return true;
    cookieDiffing = true;

    if(location.href.includes('/distributor/supplier/mine') || location.href.includes('/hyc/bulkShelves') || location.href.includes('/hyc/batchBulkShelves') || location.href.includes('/hyc/groupBulkShelves')){
      return false;
    }else{
      store.dispatch('LOGOUT');
      window.alert('账号登录信息发生变化，为避免误操作，将会刷新页面！');
      
      window.location.href = window.location.origin + '/?hasCookie=true';
      return true;;
    }
    
  }
  return false;
};

const placeholderFn = () => {};

function isErpRequest(url) {
  const erpHost = 'superboss.cc';
  return url.indexOf(erpHost) > -1;
}
function formatUrl(url) {
  // 快麦通直连erp的接口不需要加 json
  if (isErpRequest(url)) {
    return url;
  }
  // 后端接口请求统一加上.json
  const queryIndex = url.indexOf('?');
  let _url = '';
  if (queryIndex > -1) {
    _url = url.slice(0, queryIndex) + '.json' + url.slice(queryIndex);
  } else {
    _url = url + '.json';
  }
  return BASEURL ? (_url.indexOf('/') === 0 ? `/${BASEURL}` : `/${BASEURL}/`) + _url: _url;
}

function formatOpt(url, type, data, params) {
  const { isNeedTrackId = true } = params;
  let opts = {
    method: type,
    url: formatUrl(url),
    data,
    ...params,
  };
  if (params.appJson) {
    opts.headers = {
      'Content-Type': 'application/json'
    };
  }
  if (isNeedTrackId) {
    opts.trackId = `trackid${new Date().getTime()}_${(Math.random() * 100000).toFixed(0)}`;
  }
  opts.params = ['get','delete'].includes(type) ? data : undefined;
  if(params.queryInUrl){ // post接口参数支持放在地址栏上
    opts.params = data
  }
  // opts.params = type === 'get' ? data : undefined;
  if (isErpRequest(opts.url)) {
    opts.withCredentials = true;
  }
  return opts;
}

let logoutMsgIns = null; // 登出轻提示实例
function send(type = 'get', url, data = {}, params = {}) {
  // const Loading = window._globel_vm ? window._globel_vm.$loading : placeholderFn;
  const Loading = Vue.prototype.$loading;
  if (!params.isSilentRequest && isDiffCookie(url, params)) {
    return new Promise((resovle, reject) => {
      reject('用户信息更新');
    });
    // return false
  }
  const opts = formatOpt(url, type, data, params);
  if (params.isNeedLoading && !loadingService) {
    loadingService = Loading({ fullscreen: true });
  }
  if (params.isNeedLoading) {
    opts.uniqueKey = `uniqueKey${new Date().getTime()}_${(Math.random() * 100000).toFixed(0)}`;
    axios.loadingRequestQueue.push(opts);
  }


  return new Promise((resolve, reject) => {
    axios(opts)
      .then(res => {
        const Message = window._globel_vm ? window._globel_vm.$message : placeholderFn;
        if (!res) {
          // 请求被取消
          // closeLoading();
          return;
        }
        if (res.data?.result) {
          res.data.result = Number(res.data.result);
        }

        /**
         * 铺货容量/平台资料额度刷新
         * 说明：
         * - 统一在请求层收口，避免在页面/组件/平台实现中分散维护
         * - 命中铺货相关接口且成功（result=1/902）时，强制刷新 store 中的配额与容量数据
         * 规则：
         * - 铺货任务发起：/taskScheduling/storageTask、/api/ocean/call/batch/publish/item、/item/platform/publish、任意前缀/batchPublishItem
         * - 铺货进度查询：仅当返回 finished=true 时刷新（/item/platform/queryPublishSpeed、/taskScheduling/queryTaskSpeed）
         */
        const shouldRefreshPlatformQuota = (() => {
          if (!url || !res.data) return false;
          if (!(res.data.result === 1 || res.data.result === 902)) return false;
          const urlStr = String(url);
          if (urlStr.startsWith('/taskScheduling/storageTask')) return true;
          if (urlStr.startsWith('/api/ocean/call/batch/publish/item')) return true;
          if (urlStr.startsWith('/item/platform/publish')) return true;
          if (urlStr.includes('/batchPublishItem')) return true;
          if (urlStr.startsWith('/item/platform/queryPublishSpeed') || urlStr.startsWith('/taskScheduling/queryTaskSpeed')) {
            return !!res.data.data && res.data.data.finished === true;
          }
          return false;
        })();

        if (shouldRefreshPlatformQuota) {
          store.dispatch('fetchPlatformQuota', { force: true }).catch(() => {});
        }

        if (res.data && (res.data.result === 1 || res.data.result === 902)) {
          resolve(res.data);
        } else if (params.isSilentRequest) {
          reject(res.data);
        } else if (res.data.result === 901) {
          if (params.noTips) return reject(res.data);
          // const islogin = isUnlogin();
          // debugger
          if (isUnlogin()) return;
          if (logoutMsgIns) return;
          store.dispatch('LOGOUT');
          logoutMsgIns = Message.warning({
            message: '登录已过期, 请重新登录',
            onClose: () => {
              logoutMsgIns = null;
            },
          });
          reject({ msg: '登录已过期, 请重新登录' });
        } else if(res.data.result === 903 && res.data.message.includes('scm')){ // message中会返回erp的域名，过滤下
          window.location.href = res.data.message;
        } else if (res.data.result === 302) {
          // 需要重定向跳转
          window.location.href = res.data.message;
        } else if (res.data.result === 10) {
          showAuthenticationDialog()?.show();
        } else if (res.config.url === '/user/getCompanyInfo.json') {
          resolve(res.data);
        } else {
          if (!params.isNeedFailNotice) {
            let errmsg = res.data.message || res.data.errmsg || result_list[res.data.result];
            errmsg = _errResp(errmsg); // 如果错误信息包含这个验证字段就将错误信息改为提示去erp
            res.data.result !== 903 && Message.warning(errmsg);
          }
          resolve(res.data);
        }
        // closeLoading();
      })
      .catch(error => {
        // closeLoading();
        reject(error);
      })
      .finally(() => {
        compareLoadingStatus(opts.uniqueKey);
      });
  });
}

// 901 902 903 不用报错有额外的业务处理
export function get(url, data = {}, params = {}) {
  let interfaceParams = Object.assign({}, initConfig, params);
  data.api_name = get_api_name(url);
  return send('get', url, data, interfaceParams);
}

export function post(url, data = {}, params = {}) {
  let interfaceParams = Object.assign({}, initConfig, params);
  const submitType = interfaceParams.submitType || 'formData';
  data.api_name = get_api_name(url);
  if (submitType === 'formData') {
    data = qs.stringify(data);
  }
  delete interfaceParams.submitType;
  return send('post', url, data, interfaceParams);
}
export function deleteRequest(url, data = {}, params = {}) {
  let interfaceParams = Object.assign({paramsSerializer:(p) => qs.stringify(p,{arrayFormat:'repeat'})}, initConfig, params);
  const submitType = interfaceParams.submitType || 'formData';
  data.api_name = get_api_name(url);
  if (submitType === 'formData') {
    data = qs.stringify(data);
  }
  delete interfaceParams.submitType;
  return send('delete', url, data, interfaceParams);
}

export function request(url, data = {}, params = {}) {
  let interfaceParams = Object.assign({}, initConfig, params);
  const submitType = interfaceParams.submitType || 'formData';
  if (submitType === 'formData') {
    data = qs.stringify(data);
  }
  delete interfaceParams.submitType;
  return send('request', url, data, interfaceParams);
}

export function upload(url, data = {}, params = {}) {
  let interfaceParams = Object.assign({}, initConfig, params);
  delete interfaceParams.submitType;

  return send('post', url, data, interfaceParams);
}

export const resultList = result_list;
